import { Analytics } from '@analytics';
import GreenTick from '@assets/images/tip_direct/GreenTick.svg';
import LightningIcon from '@assets/images/tip_direct/LightningBolt.png';
import UpSell_BannerImage from '@assets/images/tip_direct/UpSell_BannerImage.jpg';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import CustomizableModal from '../../Common/CustomizableModal';
import messages from './messages';

const useStyles = makeStyles({
  title: {
    fontSize: '16px!important',
    fontWeight: `700!important`,
    color: '#1e293b!important',
    textAlign: 'center',
    marginTop: '20px!important',
    marginBottom: '10px!important'
  },
  modalStyle: {
    '& .MuiPaper-root': {
      borderRadius: '24px'
    }
  },
  tryButton: {
    width: '100%',
    backgroundColor: '#4f46e5',
    color: '#fff',
    paddingTop: '17px',
    paddingBottom: '17px',
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    borderRadius: '12px',
    boxShadow: 'none',

    '&:hover': {
      backgroundColor: '#4338ca',
      boxShadow: 'none'
    }
  }
});

const ProPlanModal = ({ isOpen, onClose, user }) => {
  const intl = useIntl();
  const classes = useStyles();

  const features = {
    essentialFeatures: intl.formatMessage(messages.essentialFeatures),
    reviewCollection: intl.formatMessage(messages.reviewCollection),
    resourceCollection: intl.formatMessage(messages.resourceCollection),
    guideTipSharing: intl.formatMessage(messages.guideTipSharing),
    nfcCards: intl.formatMessage(messages.nfcCards),
    customerService: intl.formatMessage(messages.customerService)
  };

  const modalBody = () => {
    return (
      <>
        <img className="w-full" src={UpSell_BannerImage} alt="Tip Direct Example" />

        <div className="text-slate-800 p-5">
          <h2 className="text-xl font-bold text-slate-800 tracking-tight mt-0 mb-2">
            {intl.formatMessage(messages.bodyTitle)}
          </h2>
          <p className="text-base text-slate-600 mt-0 mb-3 max-w-[500px]">
            {intl.formatMessage(messages.bodyDesc)}
          </p>
          <h3 className="text-sm font-bold text-slate-800 my-3">
            {intl.formatMessage(messages.includesBlockTitle)}
          </h3>
          <ul className="list-none p-0 flex flex-col gap-2 mb-0">
            {Object.keys(features).map((feature, index) => (
              <li key={index} className="flex items-center gap-3 text-slate-700">
                <img className="w-[17px] h-[17px]" src={GreenTick} alt="Green Tick" />
                {features[feature]}
              </li>
            ))}
          </ul>
          <div className="flex flex-col gap-4 mt-4">
            <Button
              className={classes.tryButton}
              color="primary"
              onClick={() => {
                Analytics.track('Try Pro for Free clicked');
                window.open(
                  `https://${user.region.toLowerCase()}.tip.direct/settings/pricingTable`,
                  '_blank'
                );
              }}>
              <img className="w-5 h-[25px] mr-2.5" src={LightningIcon} alt="Lightning" />
              <span>{intl.formatMessage(messages.tryProForFree)}</span>
            </Button>
          </div>
        </div>
      </>
    );
  };

  return (
    <CustomizableModal
      modern
      isOpen={isOpen}
      onClose={onClose}
      title={intl.formatMessage(messages.title)}
      titleStyle={classes.title}
      modalStyle={classes.modalStyle}
      body={modalBody()}
      withHeader={true}
      withBody={true}
      withFooter={false}
      bodyPadding={false}
      handleHeaderCloseButton={onClose}
    />
  );
};

const mapStateToProps = state => ({
  user: state.user?.user
});

export default connect(mapStateToProps)(ProPlanModal);
